import { setBedrockProviderModule } from "@elyracode/ai";
import { bedrockProviderModule } from "@elyracode/ai/bedrock-provider";

setBedrockProviderModule(bedrockProviderModule);
